import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgAlcohol = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#60D15D"
      d="M19 11a1 1 0 1 0 0-2 1 1 0 0 0 0 2M22.5 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M20.5 13a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M28 16.46V14h-4v2.46A1.54 1.54 0 0 1 22.46 18 2.46 2.46 0 0 0 20 20.46v11.71A1.83 1.83 0 0 0 21.83 34h8.34A1.83 1.83 0 0 0 32 32.17V20.46A2.46 2.46 0 0 0 29.54 18 1.54 1.54 0 0 1 28 16.46"
    />
    <path
      fill="#B3E9B1"
      d="M15 12.29V8h-4v4.29A1.7 1.7 0 0 1 9.29 14 1.29 1.29 0 0 0 8 15.29v18a.69.69 0 0 0 .69.69h8.62a.69.69 0 0 0 .69-.69v-18A1.29 1.29 0 0 0 16.71 14 1.7 1.7 0 0 1 15 12.29"
    />
    <path
      fill="#60D15D"
      d="M15 6h-4v2h4zM28 12h-4v2h4zM16 18h-6v12h6z"
    />
    <path
      fill="#B3E9B1"
      d="M26 22h-6v8h6z"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M9.5 18.92H14v1h-3.5V26h-1zM28 14.5h-4v-1h4z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgAlcohol);

export default ForwardRef;
